import { FC, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useAppSelector } from '../../hooks/reduxHooks';

import Seo from '../../components/Seo/Seo';
import Categories from '../../components/Categories/Categories';
import './CatalogPage.scss';

const CatalogPage:FC = () => {
    const { t } = useTranslation();
    const currentLanguage = useAppSelector(state => state.languages.curentLang);

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [])
    
    return (
        <>
            <Seo 
                title="Вітамін - 2015 (Eva) | Каталог соків, пюре, чаїв та сиропів" 
                description = 'Каталог продукції «Вітамін - 2015» (Eva): натуральні українські соки, концентрати, фруктові пюре, чаї та сиропи від Єва. Купуйте оптом і в роздріб.'
            />
            <section className="catalog-page">
            <div className="container">
                <div className="bread-crumbs">
                    <Link className='bread-crumbs__item' to='/home'>{t("nav.main")}</Link>
                    <span className='bread-crumbs__item'>{t("nav.categories")}</span>
                </div>
            </div>
            <Categories />
        </section>
        </>
    )
}

export default CatalogPage